export default class BuildingLimitsCommercial {

	public building: number | null = null;
	public contents: number | null = null;
	public businessIncomeExtraExpense: number | null = null;

	public constructor() {

	}
};